import { isInternalToolingAvailable } from "../config/mobileRuntime";

export function isLocalDevelopmentHost() {
  if (typeof window === "undefined" || !isInternalToolingAvailable()) return false;
  const host = String(window.location.hostname || "").trim().toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}
